<template>
  <div class="uebersicht">
    <div class="columns">
      <div class="column" style="text-align:left;">

      </div>
      <div class="column">

      </div>
      <div class="column">

      </div>
      <div class="column">
        <b-field>
            <b-input placeholder="Suche..."
                type="search"
                icon="magnify"
                 v-model="search">
            </b-input>
        </b-field>
      </div>
    </div>
    <b-table class="commissions" :data="data" :loading="loading" checkable hoverable>
      <template slot-scope="props">
        <b-table-column field="id" label="ID" sortable>
            {{ props.row.id }}
        </b-table-column>
        <b-table-column field="uploaddate" label="Upload-Datum" sortable>
            {{ formatDate(props.row.uploaddate) }}
        </b-table-column>
        <b-table-column  field="subject" label="Verwendungszweck" sortable>
            {{ props.row.subject}}
        </b-table-column>
        <b-table-column  field="pflichtangabenVerzicht" label="Pflichtangaben-Verzicht" sortable>
          <b-icon v-if="props.row.pflichtangabenVerzicht"
                  icon="check"
                  size="is-small">
          </b-icon>
          <b-icon v-if="!props.row.pflichtangabenVerzicht"
                  icon="close"
                  size="is-small">
          </b-icon>
        </b-table-column>
        <b-table-column  field="clamavProcessed" label="Virenprüfung-Processed" sortable>
          <b-icon v-if="props.row.clamavProcessed"
                  icon="check"
                  size="is-small">
          </b-icon>
          <b-icon v-if="!props.row.clamavProcessed"
                  icon="close"
                  size="is-small">
          </b-icon>
        </b-table-column>
        <b-table-column  field="dropboxProcessed" label="Dropbox-Processed" sortable>
          <b-icon v-if="props.row.dropboxProcessed"
                  icon="check"
                  size="is-small">
          </b-icon>
          <b-icon v-if="!props.row.dropboxProcessed"
                  icon="close"
                  size="is-small">
          </b-icon>
        </b-table-column>
        <b-table-column  field="zohoProcessed" label="Zoho-Processed" sortable>
            <b-icon v-if="props.row.zohoProcessed"
              icon="check"
              size="is-small">
          </b-icon>
            <b-icon v-if="!props.row.zohoProcessed"
              icon="close"
              size="is-small">
          </b-icon>
        </b-table-column>
        <b-table-column  field="copydruckProcessed" label="Copydruck-Processed" sortable>
            <b-icon v-if="props.row.copydruckProcessed"
              icon="check"
              size="is-small">
          </b-icon>
            <b-icon v-if="!props.row.copydruckProcessed"
              icon="close"
              size="is-small">
          </b-icon>
        </b-table-column>
        <b-table-column  field="virusDetected" label="Virus-Detected" sortable>
          <b-icon v-if="props.row.virusDetected"
                  icon="check"
                  size="is-small">
          </b-icon>
          <b-icon v-if="!props.row.virusDetected"
                  icon="close"
                  size="is-small">
          </b-icon>
        </b-table-column>
      <b-table-column  custom-key="actions">
        <div style="width:60px;">
        <button  style="border:0px;margin-right:7px;" class="button is-small" @click="editItem(props.row)">
        <b-icon type="is-primary" icon="pencil"></b-icon>
        </button>
         <button style="border:0px;" class="button is-small" @click="deleteItem(props.row)">
        <b-icon type="is-danger" icon="delete"></b-icon>
        </button>
      </div>
      </b-table-column>
    </template>

    <!--<template slot="detail" slot-scope="props">
      <tabledetail :row="props.row"></tabledetail>
    </template>-->

    <template slot="empty">
              <section class="section">
                  <div class="content has-text-grey has-text-centered">
                      <p>
                          <b-icon
                              icon="emoticon-sad"
                              size="is-large">
                          </b-icon>
                      </p>
                      <p>Keine Bilduploads gefunden.</p>
                  </div>
              </section>
          </template>

      </b-table>
    </b-table>
  </div>
</template>

<script>
// @ is an alias to /src

const axios = require('axios');
var moment = require('moment');

export default {
  name: "home",
  components: {
  //  HelloWorld
},
data() {
      return {
          search: "",
          loading: true,
          data: [],
          allData: [] //Für Suchfunktion nötig
      }
  },
  watch: {
    search: function(val) {
      console.log("Suche");
      console.log(val);
      console.log(this.allData);
      val = val.toLowerCase();

      this.data =  _.filter(this.allData, function(obj) {
        var name = obj.subject;
        name = name.toLowerCase();
        if (name.indexOf(val) >= 0) {
         return true;
        }
      });
    },
  },
  mounted: function () {
    this.loadItems();
  },
  methods: {
    loadItems: function() {
      //Get-Game
      var _this = this;
      _this.loading = true;
      axios.get('/api/imageuploads', {
        withCredentials: true,
      })
      .then(function (response) {
        console.log(response.data);
        _this.data = response.data;
        _this.allData = response.data;
        _this.loading = false;
      })
      .catch(function (error) {
        console.log(error);
          _this.loading = false;
      })
      .then(function () {
        // always executed
      });

    },
    deleteItem: function(item) {
      console.log("DELETE "+item.id);
      console.log(this.search);
      var vm = this;
      this.$buefy.dialog.confirm({
        title: 'Auftrag löschen',
        message: 'Soll der Auftrag wirklich gelöscht werden?',
        confirmText: 'Auftrag löschen',
        type: 'is-danger',
        hasIcon: true,
        cancelText: 'Abbrechen',
        onConfirm: function() {
          console.log(vm.search);
          axios.delete('/api/imageuploads/'+item.id, {
            withCredentials: true,
          })
          .then(function (response) {
            console.log(response.data);
             vm.$buefy.toast.open('Der Auftrag wurde gelöscht!');
             vm.loadItems();
          })
          .catch(function (error) {

          })
          .then(function () {
            // always executed
          });

         }
       })
    },

    editItem: function(item) {
      console.log("EDIT "+item.id);
      this.$router.push({ name: 'editcommission', params: { id: item.id } })
    },
    formatDate: function(timestamp) {
      return moment(timestamp).format("DD.MM.YYYY HH:mm");
    //  return new Date(timestamp).toLocaleDateString("de-DE")
    }
  }
};
</script>
<style>
.b-table.offers .table {
  font-size: 12px;
}
.b-table.offers .table td, .b-table.offers .table th {
  padding: 4px 4px;
}
</style>
